module.exports = __webpack_public_path__ + "static/media/Edit.371f1b4f.svg";